import { TicketType } from '@nkr/enums/index';
import { TicketTier } from '@nkr/enums/ticket-tier';
import { SearchBy } from './search-by';

export interface ITicketListRequest {
    ticketType?: TicketType,
    ticketGroupId?: number,
    ticketTier?: TicketTier,
    statusList?: number[],
    centerId?: number,
    searchBy?: SearchBy,
    searchValue?: string,
    startDate: string,
    endDate: string,
    allOpen: boolean
}